<template>
  <div>
    <div class="container-fluid right_wrapper guard_css">
      <AddGuardrailHeader></AddGuardrailHeader>
      <AddGuardrailForm class="table_wrap no_footer pt-2 bold_arrow"></AddGuardrailForm>
    </div>
  </div>
</template>

<script>
import AddGuardrailHeader from "@/components/add-guardrail/AddGuardrailHeader";
import AddGuardrailForm from "@/components/add-guardrail/AddGuardrailForm";

export default {
  components: {
    AddGuardrailHeader,
    AddGuardrailForm,
  },
};
</script>

<style lang="scss"></style>
